import Client from '@/api/client'
import { getConfig } from '@/app/config'

import { APISubscriptionResponse, SubscriptionsResult } from '../domain/subscription'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export const getSubscriptions = async (entityId: string): Promise<SubscriptionsResult> => {
  const result = await client.get<APISubscriptionResponse | undefined>(
    `/api/subscriptions/v2/subscriptions?referenceIDs=${entityId}`
  )

  return {
    users: [
      ...(result?.actors?.users || []).map((user) => ({
        id: user.id,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
      })),
      ...(result?.subscriptions || []).flatMap((subscription) =>
        subscription.contacts.map((contact) => ({
          id: contact.id,
          name: contact.contactPerson ?? '-',
          email: contact.email ?? '-',
        }))
      ),
    ],
    freighties: (result?.actors?.forties || []).map((fortie) => ({
      id: fortie.id ?? 'unknown',
      name: fortie.name,
      email: fortie.email,
      thumbnailUrl: fortie.thumbnailUrl,
    })),
  }
}

export type DeleteSubscriptionProps = {
  entityId: string
  userId: string
}

export const deleteSubscription = async (props: DeleteSubscriptionProps): Promise<void> => {
  return await client.post<void>(`/api/subscriptions/v2/subscriptions/remove/${props.entityId}`, {
    userId: props.userId,
  })
}

export type CreateSubscriptionProps = {
  entityId: string
  userId: string
}

export const createSubscription = async (props: CreateSubscriptionProps): Promise<void> => {
  return await client.post<void>(`/api/subscriptions/v2/subscriptions/add/${props.entityId}`, {
    userId: props.userId,
  })
}
